export const EMPTY_FX_RATES_META = {
  source: null,
  fetchedAt: null,
  effectiveDate: null,
  stale: false,
  snapshotId: null,
  base: "COP",
  loadedAt: null,
  isFallback: false,
  asOf: null,
  ttlSeconds: null,
};

function readMetaField(payload, field) {
  const nested = payload?.meta;
  if (nested && typeof nested === "object" && nested[field] != null) {
    return nested[field];
  }
  return payload?.[field];
}

function formatEffectiveDate(value) {
  if (value == null || value === "") {
    return null;
  }
  return String(value).slice(0, 10);
}

/**
 * Normalize `/api/fx/rates` payload metadata into a stable client shape.
 */
export function buildFxRatesMeta(payload = {}, { isFallback = false, loadedAt = new Date().toISOString() } = {}) {
  const source = readMetaField(payload, "source") ?? null;
  const fetchedAt = readMetaField(payload, "fetchedAt") ?? null;
  const effectiveDate = formatEffectiveDate(
    readMetaField(payload, "effectiveDate") ?? readMetaField(payload, "asOf")
  );
  const stale = Boolean(readMetaField(payload, "stale"));
  const snapshotId = readMetaField(payload, "snapshotId") ?? null;
  const base = payload?.base || readMetaField(payload, "base") || "COP";
  const ttlSeconds = readMetaField(payload, "ttlSeconds") ?? null;
  const resolvedFallback =
    isFallback || source === "fallback" || payload?.source === "fallback";

  return {
    source,
    fetchedAt,
    effectiveDate,
    stale,
    snapshotId,
    base,
    loadedAt,
    isFallback: resolvedFallback,
    asOf: effectiveDate,
    ttlSeconds,
  };
}
